export { MenuAlt4 as default } from './MenuAlt4';
